/**
 * Losi Inference LiveKit env helpers
 */

export function getLosiInferenceLiveKitUrl() {
  return (
    process.env.LIVEKIT_URL?.trim() ||
    process.env.NEXT_PUBLIC_LIVEKIT_URL?.trim() ||
    ''
  )
}

export function getLosiInferenceApiKey() {
  return process.env.LIVEKIT_API_KEY?.trim() || ''
}

export function getLosiInferenceApiSecret() {
  return process.env.LIVEKIT_API_SECRET?.trim() || ''
}

export function isLosiInferenceConfigured() {
  return Boolean(
    getLosiInferenceLiveKitUrl() &&
      getLosiInferenceApiKey() &&
      getLosiInferenceApiSecret()
  )
}
